import React from "react";
import "./DietDeactivate.scss";

import Button from "../../Button/Button";

import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";

interface DietDeactivateProps {
  selectedDietData: any;
  patientDetails: any;
  onConfirm: () => void;
  onCancel: () => void;
}

const DietDeactivate: React.FC<DietDeactivateProps> = ({
  selectedDietData,
  patientDetails,
  onConfirm,
  onCancel,
}) => {
  const { updateStatus } = useSelector((state: RootState) => state.diet);
  return (
    <div className="diet-deactivate-container">
      <div className="popup-text">
        You are about to deactivate the current plan for&nbsp;
        <b>{patientDetails.data?.name}</b>
        <br />
        <p>
          <span>
            <b>Plan name:</b>&nbsp;{selectedDietData?.plan_name}
          </span>
          <span>
            <b>Duration:</b>&nbsp;
            {`${selectedDietData?.start_date} to ${selectedDietData?.end_date}`}
          </span>
        </p>
        <p>
          This action will end the current diet plan. To continue you'll need to
          assign a new diet plan starting from today's date.
          <br /><br />
          <b>Are you sure you want to proceed?</b>
        </p>
      </div>

      <div className="popup-actions">
        <Button
          variant="outlined"
          onClick={onCancel}
          disabled={updateStatus.isLoading}
          // loading={updateStatus.isLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={updateStatus.isLoading}
          loading={updateStatus.isLoading}
        >
          Deactivate
        </Button>
      </div>
    </div>
  );
};

export default DietDeactivate;
